import { render, staticRenderFns } from "./UserSelectToken.vue?vue&type=template&id=122b596e&scoped=true"
import script from "./UserSelectToken.vue?vue&type=script&lang=js"
export * from "./UserSelectToken.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "122b596e",
  null
  
)

export default component.exports